module.exports = __webpack_public_path__ + "fonts/NotoSansKR-Black.0eae4f55.woff2";